

const faunadb = require('faunadb')
const q = faunadb.query


/**********************
 * Clients
 */
let userClient = null
let analistClient = null

export const activateUserClient = ({ key }) => {
  if (userClient === null) {
    userClient = new faunadb.Client({
      secret: key
    })
  }
}

export const activateAnalistClient = ({ key }) => {
  if (analistClient === null) {
    analistClient = new faunadb.Client({
      secret: key
    })
  }
}

export const isActive = () => {
  return userClient !== null
}

export const clearClients = () => {
  userClient = null
  analistClient = null
}

/**
 * Map Configuration
 */

export const getConfig = ({ ref }) => {
  return getOne({ ref, client: analistClient })
}

/**********************
 * ChargingLocations
 */

export const addChargingLocation = ({ data }) => {
  return addToCollection({ collection: "ChargingLocations", data, client: analistClient })
}

// TODO: Changing to a single record for charging locations creates problems with multiple users...
// TODO: Switch to Firebase ??
export const updateChargingLocation = ({ data, ref }) => {
  return updateOne({ ref, data, client: analistClient })
}

export const deleteChargingLocation = ({ ref }) => {
  return deleteOne({ ref, client: analistClient })
}

export const getChargingLocations = () => {
  return getAll({ indexRef: 'indexes/all_charginglocations', client: userClient })
}


/**********************
 * GENERIC FUNCTIONS
 */

export const getOne = ({ ref, client }) => {
  return client.query(q.Get(q.Ref(ref)))
}

export const deleteOne = ({ ref, client }) => {
  return client.query(q.Delete(q.Ref(ref)))
}

export const updateOne = ({ ref, data, client }) => {
  return client
    .query(q.Update(q.Ref(ref), { data }))
}

export const addToCollection = ({ collection, data, client }) => {
  return client.query(
    q.Create(
      q.Collection(collection),
      { data } 
    )
  )
}

export const getAll = ({ indexRef, client }) => {
  return client
    .query(q.Paginate(q.Match(q.Ref(indexRef)), { size: 1000000 }))
    .then((response) => {
      // create new query out of refs. http://bit.ly/2LG3MLg
      const refs = response.data.map((ref) => {
        return q.Get(ref)
      })
      // then query the refs
      return client.query(refs)
        .then((ret) => {
          return ret
        })
    })
}

